export default __webpack_public_path__ + "static/media/ADCover.4619c351.webp";